'use client';

import { FC } from 'react';

import { useAuthentication, UserGroups } from '@ravago/shared/authentication';
import { Customer } from '@ravago/shared/page-data/models/features';
import { NavItem } from '@ravago/shared/radiance/components/navigation/components/NavItem/NavItem';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { DataTestSelector } from '../../../utils/format/format.utils';

interface Props {
   currentCustomer?: Customer;
   hideLabel?: boolean;
   cyLabel?: string;
   onClick?: () => void;
}

export const CustomerSwitchButton: FC<Props> = ({ currentCustomer, hideLabel, cyLabel, onClick }) => {
   const { user } = useAuthentication();
   const translate = useTranslations();

   const canSwitchCustomer =
      user &&
      (user.groups.includes(UserGroups.ravagoSalesRepresentative) ||
         user.groups.includes(UserGroups.ravagoGlobalViewer) ||
         user.groups.includes(UserGroups.ravagoGlobalEditor) ||
         user.groups.includes(UserGroups.ravagoGlobalGroupAdmin));

   if (!canSwitchCustomer) return null;

   return (
      <NavItem attributes={{ ...(cyLabel && { ...DataTestSelector(cyLabel) }) }} size="md" icon="repeat" color={4} onClick={onClick}>
         {!hideLabel && <Typography variant="body-highlight">{translate('page-consumer.header.account.switch-customer')}</Typography>}
         {!hideLabel && currentCustomer && <Typography variant="small">{currentCustomer.name}</Typography>}
      </NavItem>
   );
};
